"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Common.module.css"));
var oldTerms = [
    "10052020",
    "11162020",
    "01112021",
    "02222021",
    "04052021",
    "05172021",
    "07062021",
    "08162021",
    "09272021",
    "11082021"
];
var versionForm = {
    newVersion: "Vs. 20.4 10/13/2026",
    oldVersion: "Vs. 20.2 2/1/2024"
};
var ABQNewVersion = "Vs. 5.5 10/13/2026";
var GJNewVersion = "Vs. 20.5 10/13/2026";
function getversionForm(json_data, isNewTerm) {
    if (json_data["campus_ABQ"] == "yes") {
        return ABQNewVersion;
    }
    else if (json_data["campus_GJ"] == "yes") {
        return GJNewVersion;
    }
    else if (isNewTerm) {
        return versionForm.newVersion;
    }
    else {
        return versionForm.oldVersion;
    }
}
function Footer(props) {
    var page = props.page, json_data = props.json_data, model = props.model;
    var _a = React.useState(""), admissionAdvisorName = _a[0], setAdmissionAdvisorName = _a[1];
    React.useEffect(function () {
        var _a, _b, _c;
        if (model === null || model === void 0 ? void 0 : model.task) {
            var name_1 = ((_c = (_b = (_a = model.task) === null || _a === void 0 ? void 0 : _a.subtask) === null || _b === void 0 ? void 0 : _b.users) === null || _c === void 0 ? void 0 : _c.find(function (user) { return (user.order = 1); }).full_name) || "";
            setAdmissionAdvisorName(name_1);
        }
    }, [model === null || model === void 0 ? void 0 : model.task]);
    return (React.createElement("div", { className: styles.footerWrap },
        page === 1 && (React.createElement("p", { style: { fontSize: "12px" } },
            React.createElement("b", null, "Admission Advisor:\u00A0"),
            admissionAdvisorName)),
        React.createElement("p", { className: styles.footerLeft }, "IntelliTec College Enrollment Agreement"),
        React.createElement("p", { className: styles.footerRight },
            React.createElement("span", { className: styles.footerDescription }, getversionForm(json_data, true)),
            " ",
            "Page",
            React.createElement("span", { className: styles.footerBold }, page),
            " of",
            React.createElement("span", { className: styles.footerBold }, "3"))));
}
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,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